module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-6.51997bb4.svg";